import { Cmd, loop, Loop, LoopReducer } from 'redux-loop';

import { UploadDocumentsState, UploadDocumentsAction } from './types';
import {
  UPLOAD_DOCUMENTS_FETCH_INIT,
  UPLOAD_DOCUMENTS_FETCH_ERROR,
  UPLOAD_DOCUMENTS_FETCH_SUCCESS,
  UPLOAD_DOCUMENTS_POST_INIT,
  UPLOAD_DOCUMENTS_POST_ERROR,
  UPLOAD_DOCUMENTS_POST_SUCCESS,
  UPLOAD_DOCUMENTS_RESET,
} from './constants';
import {
  fetchUploadDocuments,
  fetchUploadDocumentsSuccess,
  fetchUploadDocumentsError,
  postUploadDocuments,
  postUploadDocumentsSuccess,
  postUploadDocumentsError,
} from './actions';

const initialState: UploadDocumentsState = {
  documents: [],
  fetchLoading: false,
  fetchSuccess: undefined,
  fetchError: undefined,
  postLoading: false,
  postSuccess: undefined,
  postError: undefined,
};

export const uploadDocumentsReducer: LoopReducer<
  UploadDocumentsState,
  UploadDocumentsAction
> = (
  state = initialState,
  action: UploadDocumentsAction
): Loop<UploadDocumentsState> | UploadDocumentsState => {
  switch (action.type) {
    case UPLOAD_DOCUMENTS_FETCH_INIT:
      return loop(
        {
          ...state,
          fetchLoading: true,
          fetchSuccess: undefined,
          fetchError: undefined,
        },
        Cmd.run(fetchUploadDocuments, {
          successActionCreator: fetchUploadDocumentsSuccess,
          failActionCreator: fetchUploadDocumentsError,
          args: [
            action.declarationData,
            action.orderIssuers,
            action.assetManagers,
            action.procurators,
            action.personType,
          ],
        })
      );

    case UPLOAD_DOCUMENTS_FETCH_ERROR:
      return {
        ...state,
        fetchLoading: false,
        fetchSuccess: undefined,
        fetchError: action.error,
      };

    case UPLOAD_DOCUMENTS_FETCH_SUCCESS:
      return {
        ...state,
        documents: action.documents,
        fetchLoading: false,
        fetchSuccess: action.payload,
        fetchError: undefined,
      };

    case UPLOAD_DOCUMENTS_POST_INIT:
      return loop(
        {
          ...state,
          postLoading: true,
          postSuccess: undefined,
          postError: undefined,
        },
        Cmd.run(postUploadDocuments, {
          successActionCreator: postUploadDocumentsSuccess,
          failActionCreator: postUploadDocumentsError,
          args: [action.clientId, action.uploads],
        })
      );

    case UPLOAD_DOCUMENTS_POST_ERROR:
      return {
        ...state,
        postLoading: false,
        postSuccess: undefined,
        postError: action.error,
      };

    case UPLOAD_DOCUMENTS_POST_SUCCESS:
      return {
        ...state,
        postLoading: false,
        postSuccess: true,
        postError: undefined,
      };

    case UPLOAD_DOCUMENTS_RESET:
      return initialState;

    default:
      return state;
  }
};
